// extracted by mini-css-extract-plugin
export default {"headerParam":"styles_headerParam__iIFHx","flexSpaceBetween":"styles_flexSpaceBetween__uxIxe","leftSide":"styles_leftSide__oeHEP","screenTitle":"styles_screenTitle__gu-Hx"};